import { Action } from '@ngrx/store';
import { Observable, take } from 'rxjs';

export function dispatchNgRxAction(
  actionDetails: { action: string },
  payload$: Observable<unknown>,
  dispatchAction: (action: Action) => void,
) {
  const action: Action & { [key: string]: unknown } = {
    type: actionDetails.action,
  };

  payload$.pipe(take(1)).subscribe((payload) => {
    if (typeof payload === 'object' && payload !== null) {
      for (const key of Object.keys(payload)) {
        const value = (payload as { [k: string]: unknown })[key];
        action[key] = value;
      }
    }

    dispatchAction(action);
  });
}
